import Vue from 'vue';
import axios from 'axios'; 
import * as files from '../../fileUtils';
import users from '../../users';
import '../../filters';
import moment from 'moment';

const edams_controls_tpl = {
  page: 'omApplication_employee',
  controls: {
    sectionJobCard:       { employee: { visible: true, disabled: false } },
    sectionProblemLog:    { employee: { visible: true, disabled: false } },
    sectionInvestigation: { employee: { visible: true, disabled: false } },
  }
};

export default {
  name: 'OmApplication',
  mixins: [users],
  components: {
    JobcardComp: require('./jobcard.vue').default,
    InvestigationComp: require('./investigation.vue').default,
    ProblemLogComp: require('./problemLog.vue').default,
  },
  data: function () {
    return {
      activeTab: '',
      edams_controls: edams_controls_tpl.controls,
      bShowSecurities: false,
      omApp: {
        type: 0,
        status: 0,
        stage: 0,
        sourceId: -1,
        investigationId: -1,
        jobcardId: -1,
        address: '',
        workflowEmployeeId: -1,
        applicationDate: new Date()
      },
      bShowProblemLog: false,
      problemLog: {
        Id: -1,
        ComplainTypeId: 0,
        ServiceTypeId: 0,
        LocationDescription: -1,
        TownshipId: -1,
        ProblemAddress: '',
        ProblemHouse: '',
        ProblemFlat: '',
        StationId: -1,
        WorkflowEmployeeId: -1,
        MActivityId: -1,
        ElementTypeId: -1,
        ElementId: -1,
        IsReadOnly: false
      },
      omAppId: -1,
      omAppTypeId: -1,
      appTypes: [],
      appStatus: [],
      appStages: [],
      dataObj: {},
      message: '',
      currentPage: 'jobcard'
    }
  },
  computed: {
    omAppType: function () {
      var item = this.appTypes.filter(d => d.id === this.omApp.type)[0];
      return (item) ? item.name: '';
    },
    omAppStatus: function () {
      var item = this.appStatus.filter(d => d.id === this.omApp.status)[0];
      return (item) ? item.name : '';
    },
    omAppStage: function () {
      var item = this.appStages.filter(d => d.id === this.omApp.stage)[0];
      return (item) ? item.name : '';
    },
  },
  created() {
    this.readSecurities(edams_controls_tpl.page, this.edams_controls);
    this.omAppId = this.$route.params.id;
    this.omAppTypeId = this.$route.params.type;
    this.getLookups();
    this.getOmApplication(this.omAppId, this.omAppTypeId);
  },
  methods: {
    tabChanged(tab) {
      if (tab != null)
        this.gotoPage(tab.slice(4))
    },
    gotoPage(page) {
      this.currentPage = page;
      this.activeTab = "tab-" + page;
      switch (page) {
        case "jobcard":
          //value.editorOptions.readOnly = true;
          break;
        case "investigation":
          //value.editorOptions.readOnly = value.row.data.isSystem === true;
          break;
        case "problemlog":
          //value.editorOptions.readOnly = !(value.row.data.isSystem === true && value.row.data.hasReading === true);
          break;
        default:
        // do nothing
      }
    },
    manageSecurities(event) {
      this.bShowSecurities = !this.bShowSecurities;
      if (this.bShowSecurities === true)
        this.showSecurities(this.edams_controls);
      else
        this.readSecurities(edams_controls_tpl.page, this.edams_controls);
    },
    getLookups() {
      axios.post('/Om/GetOmApplicationLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.appTypes = response.data.appTypes;
            this.appStatus = response.data.appStatus;
            this.appStages = response.data.appStages;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getOmApplication(id, type) {
      var parameter = { Value: id, Type: type };
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetApplication', parameter),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            response.data.omApp.omAppId = this.omAppId;
            var omApp = response.data.omApp;

            this.bShowProblemLog = omApp.sourceTypeName === "Problem Log";
            this.bShowProblemLogOnly = omApp.sourceTypeName === "Problem Log" && omApp.stage === 2 && omApp.status == 1 && omApp.type == 2;
            this.omApp = response.data.omApp;
            if (this.omApp.type === 2)
              this.getProblemLog(this.omApp.omAppId);
            this.$root.$emit('omApplication_updated');

            if (this.bShowProblemLog === true)
              this.currentPage = 'problemlog';

            if (omApp.investigationId > 0)
              this.currentPage = 'investigation';

            if (omApp.stage > 1 && this.bShowProblemLogOnly === false)
              this.currentPage = 'jobcard';

            this.gotoPage(this.currentPage);
          }
          else
            this.$alertMsg(response.data.data.text)
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Application ' + id
      );
    },
    getProblemLog(id) {
      var parameter = { Value: id };
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetProblemLog', parameter),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            this.problemLog = response.data.item;
            this.omApp.address = this.problemLog.problemAddress;
            this.omApp.address = (this.problemLog.problemHouse != null && this.problemLog.problemHouse.length > 0) ? this.omApp.address + ", House: " + this.problemLog.problemHouse : this.omApp.address;
            this.omApp.address = (this.problemLog.problemFlat != null && this.problemLog.problemFlat.length > 0) ? this.omApp.address + ", Flat: " + this.problemLog.problemFlat : this.omApp.address;

            this.$root.$emit('problemLog_updated');
          }
          else
            this.$alertMsg(response.data.data.text)
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Problem Log'
      );
    },
    close() {
      this.$router.replace("/omApplications");
    },
    closeWithMessage(msg, type, timeout=3000) {
      this.message = msg;
      if (type == 1)
        this.message += ' If the problem repeats please contact Support';
      this.$alertMsg(msg);
      setTimeout(function () { this.close(); }.bind(this), timeout);
    },
    roStyle: function () {
      return !this.app || this.app.customerServicesOmApplicationId > 0 ? { 'pointer-events': 'none' } : {};
    }
  }

}

